import "./styles/main.css";
import { createApp } from "vue";

//store
import { createPinia } from "pinia";

//libraries
import Antd from "ant-design-vue";
import VueTelInput from "vue-tel-input";
import "vue-tel-input/vue-tel-input.css";

//vue-i18n
import { createI18n } from "vue-i18n";

//vue-date-picker
import "@vuepic/vue-datepicker/dist/main.css";
import VueDatePicker from "@vuepic/vue-datepicker";

//primevue
import Column from "primevue/column";
import Ripple from "primevue/ripple";

import PrimeVue from "primevue/config";
import Aura from "@primevue/themes/aura";
import ToastService from "primevue/toastservice";
import DataTable from "primevue/datatable";

import "primeicons/primeicons.css"; // icons
import VueApexCharts from "vue3-apexcharts";

//custom components
import Ecclipse from "@/assets/svg/ecclipse.svg";
import TabVue from "@/components/UI/Table/tab.vue";
import Loader from "@/components/UI/Loader/Loader.vue";
import Avatar from "@/components/UI/Avatar/Avatar.vue";
import ButtonVue from "@/components/UI/Buttons/Button.vue";
import ErrorPage from "@/components/UI/ErrorPage/index.vue";
import Calendar from "@/components/UI/Calendar/Calendar.vue";
import InputTag from "@/components/UI/Inputs/EpumpInput.vue";
import FilterVue from "@/components/UI/Table/filterGroup.vue";
import DropdownVue from "@/components/UI/dropdown/dropdown.vue";
import SideDrawer from "@/components/UI/SideDrawer/SideDrawer.vue";
import ClipLoaderVue from "@/components/UI/Loader/ClipLoaderVue.vue";
import TableEmptyState from "@/components/UI/Table/TableEmptyState.vue";
import BottomDrawer from "@/components/UI/BottomDrawer/BottomDrawer.vue";
import EpumpInput from "@/components/UI/Inputs/EpumpInput.vue";
import StatusColumn from "@/components/UI/Table/columnStyling/status.vue";
import ConfirmPassword from "@/components/UI/ConfirmPassword/ConfirmPassword.vue";
import ConnectionStatus from "@/components/UI/Table/columnStyling/ConnectionStatus.vue";
import ConfirmationModal from "@/components/UI/ConfirmationModal/ConfirmationModal.vue";
import CustomToast from "./components/UI/Toast/customToast.vue";
import TableExport from "@/components/UI/Table/TableExport.vue";
import PushERP from "@/components/UI/Table/PushERP.vue";
import TableFilter from "@/components/UI/Table/TableFilter.vue";
import TablePagination from "@/components/UI/Table/TablePagination.vue";
import Menu from "primevue/menu";
import Button from "primevue/button";
import Tank from "@/components/UI/Tank/index.vue";
import InputSystem from "@/components/UI/Inputs/InputSystem.vue";
import TagList from "@/components/UI/Table/columnStyling/tags.vue";
import newDropDown from "./components/UI/dropdown/newDropDown.vue";
import ProductOilAvatar from "@/components/UI/Product/ProductOilAvatar.vue";
import Status from "@/components/UI/Table/columnStyling/status.vue";
import FlagStatus from "@/components/UI/Table/columnStyling/flagStatus.vue";
import SalesStatus from "@/components/UI/Table/columnStyling/salesType.vue";
import BreadcrumbVue from "./components/UI/breadcrumb/breadcrumb.vue";
import ToolTip from "./components/UI/Tooltip/toolTip.vue";
import SecondLoader from "@/components/UI/Loader/SecondLoader.vue";
import TopSingleSummary from "./components/UI/Card/TopSingleSummary.vue";
import ImageCarousel from "./components/UI/Image/imageCarousel.vue";

import Checkbox from "@/components/UI/Checkbox/Checkbox.vue";
import SummaryCard from "@/components/UI/Card/SummaryCard.vue";
import GeneralDeleteModal from "@/components/UI/GeneralDeleteModal/index.vue";
import TableSkeleton from "@/components/UI/Table/TableSkeleton.vue";
import DashboardCalendar from "@/components/UI/Calendar/DashboardCalendar.vue";
////////////////////////////////

import App from "./App.vue";
import router from "./router";
import { i18n } from "./translation";
import ApiService from "@/core/services/ApiService";
import AuthApiService from "@/core/services/authApiService";
import { useAuthStore } from "@/store/Auth";
import Card from "@/components/UI/Card/Card.vue";
import MultiDropdown from "./components/UI/dropdown/multiDropdown.vue";
import { handleTawkVisibility } from "./core/helpers/utility";
// import * as Sentry from "@sentry/vue";

const app = createApp(App);
// Sentry.init({
//   app,
//   dsn: "https://f4541435a552d21d2e448774012cd1d9@o4508681090301952.ingest.de.sentry.io/4508681579921488",
//   integrations: [
//     Sentry.browserTracingIntegration({ router }),
//     Sentry.replayIntegration(),
//   ],
//   // Tracing
//   tracesSampleRate: 1.0, //  Capture 100% of the transactions
//   // Set 'tracePropagationTargets' to control for which URLs distributed tracing should be enabled
//   tracePropagationTargets: ["localhost", /^https:\/\/yourserver\.io\/api/],
//   // Session Replay
//   replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
//   replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
// });

// 🚨 TAWK IMPLEMENTATION
window.Tawk_API = window.Tawk_API || {};
window.Tawk_API.onLoad = function () {
  handleTawkVisibility(router.currentRoute.value.name);
};

window.Tawk_LoadStart = new Date();

const loadTawk = () => {
  const script = document.createElement("script");
  script.async = true;
  script.src = `https://embed.tawk.to/${import.meta.env.VITE_APP_TAWK_PROPERTY_ID}/${import.meta.env.VITE_APP_TAWK_WIDGET_ID}`;
  script.charset = "UTF-8";
  script.setAttribute("crossorigin", "*");
  document.body.appendChild(script);
};

loadTawk();

const pinia = createPinia();
app.use(pinia);

const authStore = useAuthStore(pinia);
authStore.initializeCachedAuth();

app.use(i18n);
app.use(router);
app.use(Antd);
app.use(PrimeVue, {
  theme: {
    preset: Aura,
    options: {
      prefix: "p",
      darkModeSelector: "light",
      cssLayer: false,
    },
  },
});
app.use(ToastService);

app.use(VueApexCharts);
app.use(PrimeVue, { ripple: true });
app.use(VueTelInput);
// app.directive("ripple", Ripple);
app.component("Column", Column);
app.component("DataTable", DataTable);
app.component("VueDatePicker", VueDatePicker);
app.component("Menu", Menu);
app.component("Button", Button);

//custom components
app.component("Loader", Loader);
app.component("Avatar", Avatar);
app.component("TabVue", TabVue);
app.component("Calendar", Calendar);
app.component("Ecclipse", Ecclipse);
app.component("InputTag", InputTag);
app.component("ErrorPage", ErrorPage);
app.component("FilterVue", FilterVue);
app.component("ButtonVue", ButtonVue);
app.component("SideDrawer", SideDrawer);
app.component("StatusColumn", StatusColumn);
app.component("BottomDrawer", BottomDrawer);
app.component("ClipLoaderVue", ClipLoaderVue);
app.component("TableEmptyState", TableEmptyState);
app.component("ConfirmPassword", ConfirmPassword);
app.component("ModalVue", ConfirmPassword);
app.component("ConnectionStatus", ConnectionStatus);
app.component("ConfirmationModal", ConfirmationModal);
app.component("CustomToast", CustomToast);
app.component("TableExport", TableExport);
app.component("PushERP", PushERP);
app.component("TableFilter", TableFilter);
app.component("TablePagination", TablePagination);
app.component("Card", Card);
app.component("Tank", Tank);
app.component("EpumpInput", EpumpInput);
app.component("InputSystem", InputSystem);
app.component("TagList", TagList);
app.component("DropdownVue", newDropDown);
app.component("MultiDropdown", MultiDropdown);
app.component("ProductOilAvatar", ProductOilAvatar);
app.component("Status", Status);
app.component("FlagStatus", FlagStatus);
app.component("SalesStatus", SalesStatus);
app.component("BreadcrumbVue", BreadcrumbVue);
app.component("Tooltip", ToolTip);
app.component("SecondLoader", SecondLoader);
app.component("TopSingleSummary", TopSingleSummary);
app.component("Checkbox", Checkbox);
app.component("SummaryCard", SummaryCard);
app.component("GeneralDeleteModal", GeneralDeleteModal);
app.component("TableSkeleton", TableSkeleton);
app.component("ImageCarousel", ImageCarousel);
app.component("DashboardCalendar", DashboardCalendar);

///
ApiService.init(app);
AuthApiService.init(app);
app.mount("#app");
